"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSwipe = void 0;
var react_1 = require("react");
var defaultSwipeLength = 100;
var defaultLateralDeviationThreshold = 50;
var useSwipe = function (_a) {
    var onSwipe = _a.onSwipe, _b = _a.swipeLength, swipeLength = _b === void 0 ? defaultSwipeLength : _b, _c = _a.lateralDeviationThreshold, lateralDeviationThreshold = _c === void 0 ? defaultLateralDeviationThreshold : _c;
    var _d = (0, react_1.useState)(null), touchStart = _d[0], setTouchStart = _d[1];
    var _e = (0, react_1.useState)(null), touchEnd = _e[0], setTouchEnd = _e[1];
    var handleTouchEnd = (0, react_1.useCallback)(function (e) {
        if (!touchStart || !touchEnd)
            return;
        var yShift = touchEnd.y - touchStart.y;
        var xShift = touchEnd.x - touchStart.x;
        var xSize = Math.abs(xShift);
        var ySize = Math.abs(yShift);
        if (ySize < lateralDeviationThreshold && xSize > swipeLength) {
            onSwipe(xShift > 0 ? 'right' : 'left', xSize);
        }
        else if (xSize < lateralDeviationThreshold && ySize > swipeLength) {
            onSwipe(yShift > 0 ? 'down' : 'up', ySize);
        }
        setTouchStart(null);
        setTouchEnd(null);
    }, [
        touchStart,
        setTouchStart,
        touchEnd,
        setTouchEnd,
        onSwipe,
        lateralDeviationThreshold,
        swipeLength,
    ]);
    var handleTouchStart = (0, react_1.useCallback)(function (e) {
        var _a = e.targetTouches[0], x = _a.clientX, y = _a.clientY;
        setTouchStart({ x: x, y: y });
    }, [setTouchStart]);
    var handleTouchMove = (0, react_1.useCallback)(function (e) {
        var _a = e.targetTouches[0], x = _a.clientX, y = _a.clientY;
        setTouchEnd({ x: x, y: y });
    }, [setTouchEnd]);
    return {
        onTouchStart: handleTouchStart,
        onTouchMove: handleTouchMove,
        onTouchEnd: handleTouchEnd,
    };
};
exports.useSwipe = useSwipe;
//# sourceMappingURL=swipe.js.map